import { render } from "./LoaderComponent2.vue?vue&type=template&id=4f464dac&scoped=true"
import script from "./LoaderComponent2.vue?vue&type=script&lang=js"
export * from "./LoaderComponent2.vue?vue&type=script&lang=js"

import "./LoaderComponent2.vue?vue&type=style&index=0&id=4f464dac&scoped=true&lang=css"

import exportComponent from "/home/andre/Bureau/projets-nexah/web/vuejs/web/cv-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f464dac"]])

export default __exports__